import { Button } from '../Button';

interface FooterProps {
  onClose?: () => void;
  onSubmit?: () => void;
}

export const Footer = ({ onClose, onSubmit }: FooterProps) => (
  <div className="pt-6 flex justify-end items-center">
    <Button
      onClick={onClose}
      link
      label="Cancel"
    />
    <Button
      onClick={onSubmit}
      label="Done"
    />
  </div>
);
